import { render, staticRenderFns } from "./pie-chart-card.vue?vue&type=template&id=6a70ed64&"
import script from "./pie-chart-card.vue?vue&type=script&lang=js&"
export * from "./pie-chart-card.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "pie-chart-card.vue"
export default component.exports